import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDjLPqj89V-6PuLTucWK8U1iDBFPkss61Q',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'novembr-1b758.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'novembr-1b758',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'novembr-1b758.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '224834580796',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:224834580796:web:bb7c94c114ab8882126e39',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-MTKW9H19Q3',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

if (typeof window !== 'undefined') {
  isSupported()
    .then((supported) => {
      if (supported) {
        getAnalytics(app);
      }
    })
    .catch(() => {
      // Analytics is optional.
    });
}
